import { faCoins } from '@fortawesome/pro-regular-svg-icons';
import { selectSettings } from 'ducks/settings/selectors';
import { Button } from 'framework/button';
import { useAppSelector } from 'store/hooks';

import { Avatar } from 'components/avatar/Avatar';

import { SELECT_SLIM_HEIGHT, THEME } from '../../constants';

import { NavigationProps } from './types';

import cn from './Navigation.module.scss';
const { PUBLIC_URL } = process.env;

export const Navigation = ({ children }: NavigationProps) => {
  const { offset_navigation } = useAppSelector(selectSettings);
  return (
    <div className={cn.navigation} style={{ height: offset_navigation }}>
      <img src={`${PUBLIC_URL}/voladeum/voladeum-horizontal.png`} alt="Voladeum" />
      <div className={cn.breadcrumbs}>{children}</div>
      <div className={cn.flex} />
      <Button
        height={SELECT_SLIM_HEIGHT}
        left_icon={faCoins}
        variant="secondary"
        theme={THEME.button.slim}
      >
        10,000 Credits
      </Button>
      <Avatar />
    </div>
  );
};
